import {
  GET_NEW_MEGAMENU,
  GET_NEW_MEGAMENU_SUCCESS,
  GET_NEW_MEGAMENU_LOAD_FAIL
} from './action';

const initialState = {
  loaded: false,
  editing: {},
  saveError: {},
  data: [],
  extraData: {},
};


export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_NEW_MEGAMENU:
      return {
        ...state,
        loading: true,
      };
    case GET_NEW_MEGAMENU_SUCCESS:

      return {
        ...state,
        loading: false,
        loaded: true,
        data: {
          l1Categories: action.result.megamenu
            ? action.result.megamenu
            : action.result.l1Categories,
        },
        error: null,
        extraData: 'This is extra info..........',
      };
    case GET_NEW_MEGAMENU_LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: action.error,
      };
    default:
      return state;
  }
}
